export * from './src/document-view.component';
